export default {
    GET_CURRENT_GROUP_ELEMENT: 'GET_CURRENT_GROUP_ELEMENT',
    GET_CURRENT_SOURCE_ELEMENT: 'GET_CURRENT_SOURCE_ELEMENT',
    GET_CURRENT_GROUP_SOURCE_FIELD_MAP: 'GET_CURRENT_GROUP_SOURCE_FIELD_MAP',
    GET_CURRENT_DATA_IMPORT_ELEMENT: 'GET_CURRENT_DATA_IMPORT_ELEMENT',
    SET_IMPORT_COMPARISON_RESULT: 'SET_IMPORT_COMPARISON_RESULT',
    SET_IMPORT_SETUP_MODAL_DATA: 'SET_IMPORT_SETUP_MODAL_DATA',
    CLEAR_IMPORT_COMPARISON_RESULT: 'CLEAR_IMPORT_COMPARISON_RESULT',
};
